// Ordering ke switch. Backend ready hone par yahan se badlo — code me kahin aur nahi.

/**
 * true  = rate mock se banega (sirf local/demo ke liye)
 * false = asli API call jayegi (POST /global/quote) — YAHI default hai
 *
 * Asli API 13-Sep-2026 20:57 IST se live hai. Mock wapas chalu karna ho to
 * build me REACT_APP_QUOTE_MOCK=1 set karo.
 */
export const USE_QUOTE_MOCK = process.env.REACT_APP_QUOTE_MOCK === "1";

/** Cart/checkout UI dikhana hai ya nahi. Band karna ho to REACT_APP_ORDERING_OFF=1 */
export const ORDERING_ENABLED = process.env.REACT_APP_ORDERING_OFF !== "1";
